module.exports = __webpack_public_path__ + "img/avatar1.def794f0.png";